// Woher die Anwendung kommt — Browser oder native Hülle.
//
// In der nativen App läuft die Oberfläche unter capacitor://localhost
// beziehungsweise http://localhost. Ein Aufruf von „/api/…" ginge dort ins
// Leere, weil er gegen die eingebetteten Dateien läuft und nicht gegen den
// Server. Deshalb braucht jeder Netzwerkzugriff dort eine vollständige
// Adresse.
//
// Capacitor wird bewusst NICHT importiert: so baut und läuft dieselbe Datei
// im Browser weiter, ohne dass eine Abhängigkeit mitgezogen wird, die dort
// niemand braucht. Das Objekt setzt die native Hülle selbst ins Fenster.

type CapacitorFenster = typeof globalThis & {
  Capacitor?: {
    isNativePlatform?: () => boolean;
    getPlatform?: () => string;
  };
};

const cap = () => (globalThis as CapacitorFenster).Capacitor;

/** Läuft die Anwendung in der nativen Hülle? */
export function istNativ(): boolean {
  try { return cap()?.isNativePlatform?.() === true; } catch { return false; }
}

/** 'ios', 'android' oder 'web'. */
export function plattform(): string {
  try { return cap()?.getPlatform?.() ?? 'web'; } catch { return 'web'; }
}

/**
 * Wohin die Netzwerkzugriffe gehen.
 *
 * Im Browser bleibt es leer, also relativ — da ändert sich gegenüber heute
 * nichts. In der App steht hier der Server. VITE_API_URL erlaubt, eine
 * Testfassung gegen einen anderen Server zu bauen, ohne Code zu ändern.
 */
export const API_URSPRUNG: string = istNativ()
  ? (import.meta.env?.VITE_API_URL || 'https://lagerpro.app').replace(/\/$/, '')
  : '';

/**
 * Vollständige Adresse für einen API-Pfad.
 * Im Browser gibt sie den Pfad unverändert zurück.
 */
export function apiUrl(pfad: string): string {
  if (!API_URSPRUNG) return pfad;
  return pfad.startsWith('/') ? API_URSPRUNG + pfad : `${API_URSPRUNG}/${pfad}`;
}
